import React from 'react'
import Form from 'react-bootstrap/Form';
import {SearchIcon} from "../../../../styles/img/svg/SearchIcon"

export default function UiFiterInput(props) {

    return (
        <>
            <div className='sb-fiter-search'>
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder={props.placeholder}
                        value={props.value}
                        id={props.label}
                        
                    />
                    <SearchIcon/>
                     <Form.Control.Feedback type={props.errorType}>
                        {props.errorMsg}
                    </Form.Control.Feedback>
                </Form.Group>
            </div>
        </>
    )
}

